import styled from "styled-components";

export const CategoryBox = styled.div`
    display: flex;
    align-items: center;
    border-radius: 11px;
    padding: 15px;
    cursor: pointer;
    width: 250px;
    height: 30px;
    gap: 8px;
    text-decoration: none;
    font-weight: 400;
    font-family: 'Lato';
    color: #102051;
    box-shadow: 1px 1px 5px #102051;

    &:hover {
        color: white;
        background-color: #102051;
    }

    @media (max-width: 768px) {
        width: 37vw;

            &:active {
                color: white;
                background-color: #102051;
            }
    }
    @media (max-width: 1024px) and (min-width: 769px) {
        width: 200px;
    }
`
export const StoreImage = styled.img`
    height: 40px;
    width: 40px;
    border-radius: 50%;

    /* @media (max-width: 768px) {
        width: 100px;
    } */

`
